export default {
  geolocation: {
    lat: '4.598',
    lng: '-74.080',
    label: '111611 Bogotá',
  },
  price_rules: {
    grouping: '.',
    decimal: ',',
  },
}
